module.exports = __webpack_public_path__ + "static/media/WEO76APP0002.f8a54040.svg";